var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import "../styles/ArtGeneratorSettings.css";
import ArtGeneratorService from "../services/ArtGeneratorService";
import { handleServiceError } from "../../App/components/ErrorHandler";
import useContentSuppliers from "../../App/hooks/useContentSuppliers";
import SectionTitle from "../components/Settings/SectionTitle";
import PhraseManager from "../components/Settings/PhraseManager";
import ColorManager from "../components/Settings/ColorManager";
import CollapsibleGroup from "../components/Settings/CollapsibleGroup";
import ImageGallery from "../components/Settings/ImageGallery";
function ArtGeneratorSettings() {
    var _this = this;
    var _a = useContentSuppliers(), contentSuppliersProducts = _a.contentSuppliersProducts, getAllContentSuppliersProducts = _a.getAllContentSuppliersProducts;
    var _b = useState([]), titles = _b[0], setTitles = _b[1];
    var _c = useState([]), infos = _c[0], setInfos = _c[1];
    var _d = useState([]), colors = _d[0], setColors = _d[1];
    var _e = useState([]), images = _e[0], setImages = _e[1];
    var _f = useState([]), orientations = _f[0], setOrientations = _f[1];
    var fetchTitles = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    _a = setTitles;
                    return [4 /*yield*/, ArtGeneratorService.getTitles()];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _b.sent();
                    handleServiceError(err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    var fetchAdditionalInfos = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var infos_1, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ArtGeneratorService.getAdditionalInfos()];
                case 1:
                    infos_1 = (_a.sent()).infos;
                    setInfos(infos_1 || []);
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    handleServiceError(err_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    var fetchColors = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, err_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    _a = setColors;
                    return [4 /*yield*/, ArtGeneratorService.getColorCombinations()];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [3 /*break*/, 3];
                case 2:
                    err_3 = _b.sent();
                    handleServiceError(err_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    var fetchImages = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, err_4;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    _a = setImages;
                    return [4 /*yield*/, ArtGeneratorService.getImages()];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [3 /*break*/, 3];
                case 2:
                    err_4 = _b.sent();
                    handleServiceError(err_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    var fetchOrientations = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, err_5;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    _a = setOrientations;
                    return [4 /*yield*/, ArtGeneratorService.getOrientations()];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [3 /*break*/, 3];
                case 2:
                    err_5 = _b.sent();
                    handleServiceError(err_5);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        fetchTitles();
        fetchAdditionalInfos();
        fetchColors();
        fetchImages();
        fetchOrientations();
        getAllContentSuppliersProducts();
    }, [fetchTitles, fetchAdditionalInfos, fetchColors, fetchImages, fetchOrientations]);
    var createTitle = function (label) { return __awaiter(_this, void 0, void 0, function () {
        var err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ArtGeneratorService.createTitle(label)];
                case 1:
                    _a.sent();
                    fetchTitles();
                    return [3 /*break*/, 3];
                case 2:
                    err_6 = _a.sent();
                    handleServiceError(err_6);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var deleteTitle = function (id) { return __awaiter(_this, void 0, void 0, function () {
        var err_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ArtGeneratorService.deleteTitle(id)];
                case 1:
                    _a.sent();
                    setTitles(function (prev) { return prev.filter(function (t) { return String(t.id) !== String(id); }); });
                    return [3 /*break*/, 3];
                case 2:
                    err_7 = _a.sent();
                    handleServiceError(err_7);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var createInfo = function (value) { return __awaiter(_this, void 0, void 0, function () {
        var err_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ArtGeneratorService.createAdditionalInfo(value)];
                case 1:
                    _a.sent();
                    fetchAdditionalInfos();
                    return [3 /*break*/, 3];
                case 2:
                    err_8 = _a.sent();
                    handleServiceError(err_8);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var deleteInfo = function (id) { return __awaiter(_this, void 0, void 0, function () {
        var err_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ArtGeneratorService.deleteAdditionalInfo(id)];
                case 1:
                    _a.sent();
                    setInfos(function (prev) { return prev.filter(function (i) { return String(i.id) !== String(id); }); });
                    return [3 /*break*/, 3];
                case 2:
                    err_9 = _a.sent();
                    handleServiceError(err_9);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var createColor = function (name, hex) { return __awaiter(_this, void 0, void 0, function () {
        var err_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ArtGeneratorService.createColorBackground({ name: name, hex: hex })];
                case 1:
                    _a.sent();
                    fetchColors();
                    return [3 /*break*/, 3];
                case 2:
                    err_10 = _a.sent();
                    handleServiceError(err_10);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var deleteColor = function (id) { return __awaiter(_this, void 0, void 0, function () {
        var err_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ArtGeneratorService.deleteColorBackground(id)];
                case 1:
                    _a.sent();
                    setColors(function (prev) { return prev.filter(function (c) { return String(c.id) !== String(id); }); });
                    return [3 /*break*/, 3];
                case 2:
                    err_11 = _a.sent();
                    handleServiceError(err_11);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var uploadImage = function (meta) { return function (file) { return __awaiter(_this, void 0, void 0, function () {
        var err_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ArtGeneratorService.uploadBackground(file, meta.orientationId, meta.productId)];
                case 1:
                    _a.sent();
                    fetchImages();
                    return [3 /*break*/, 3];
                case 2:
                    err_12 = _a.sent();
                    handleServiceError(err_12);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }; };
    var deleteImage = function (id) { return __awaiter(_this, void 0, void 0, function () {
        var err_13;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ArtGeneratorService.deleteBackground(id)];
                case 1:
                    _a.sent();
                    setImages(function (prev) { return prev.filter(function (img) { return String(img.id) !== String(id); }); });
                    return [3 /*break*/, 3];
                case 2:
                    err_13 = _a.sent();
                    handleServiceError(err_13);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var imagesByOrientation = useMemo(function () {
        return orientations.map(function (orientation) {
            var imgs = images.filter(function (img) { return String(img.orientationId) === String(orientation.id); });
            var byProduct = new Map();
            var generic = [];
            imgs.forEach(function (img) {
                if (img.category === "generic" || img.productId == null) {
                    generic.push(img);
                }
                else {
                    var key = String(img.productId);
                    if (!byProduct.has(key))
                        byProduct.set(key, []);
                    byProduct.get(key).push(img);
                }
            });
            return { orientation: orientation, total: imgs.length, byProduct: byProduct, generic: generic };
        });
    }, [images, orientations]);
    var productName = function (id) {
        var product = contentSuppliersProducts.find(function (p) { return String(p.id) === id; });
        return product ? product.name : "Produto ".concat(id);
    };
    var orientationLabel = function (name) { return (name ? name.charAt(0).toUpperCase() + name.slice(1) : "Sem orientação"); };
    return (_jsxs("div", __assign({ "data-id": "art-generator-settings", className: "content-internal-padding", style: { backgroundColor: "rgb(248,248,248)" } }, { children: [_jsx("h1", __assign({ className: "settings-page-title" }, { children: "Atualiza\u00E7\u00F5es - Gerador de Artes" })), _jsx("section", __assign({ className: "settings-section" }, { children: _jsxs("div", __assign({ className: "settings-card" }, { children: [_jsx(SectionTitle, { children: "Textos" }), _jsx(PhraseManager, { title: "Chamadas", addLabel: "Criar nova chamada", items: titles.map(function (t) { return ({ id: t.id, label: t.label }); }), onCreate: createTitle, onDelete: deleteTitle }), _jsx(PhraseManager, { title: "Informa\u00E7\u00F5es adicionais", addLabel: "Criar informa\u00E7\u00E3o adicional", items: infos.map(function (i) { return ({ id: i.id, label: i.value }); }), onCreate: createInfo, onDelete: deleteInfo })] })) })), _jsx("section", __assign({ className: "settings-section" }, { children: _jsxs("div", __assign({ className: "settings-card" }, { children: [_jsx(SectionTitle, { children: "Cores" }), _jsx(ColorManager, { items: colors.map(function (c) { return ({ id: c.id, name: c.name, hex: c.hex }); }), onCreate: createColor, onDelete: deleteColor })] })) })), _jsx("section", __assign({ className: "settings-section" }, { children: _jsxs("div", __assign({ className: "settings-card" }, { children: [_jsx(SectionTitle, { children: "Imagens" }), imagesByOrientation.map(function (_a) {
                            var orientation = _a.orientation, total = _a.total, byProduct = _a.byProduct, generic = _a.generic;
                            return (_jsxs(CollapsibleGroup, __assign({ title: orientationLabel(orientation.name), count: total }, { children: [Array.from(byProduct.entries()).map(function (_a) {
                                        var productId = _a[0], imgs = _a[1];
                                        return (_jsx(CollapsibleGroup, __assign({ level: 1, title: productName(productId), count: imgs.length }, { children: _jsx(ImageGallery, { images: imgs, onUpload: uploadImage({ orientationId: orientation.id, productId: productId }), onDelete: deleteImage }) }), productId));
                                    }), _jsx(CollapsibleGroup, __assign({ level: 1, title: "Imagens gen\u00E9ricas", count: generic.length }, { children: _jsx(ImageGallery, { images: generic, onUpload: uploadImage({ orientationId: orientation.id }), onDelete: deleteImage }) }))] }), orientation.id));
                        })] })) }))] })));
}
export default ArtGeneratorSettings;
